export const order = {
  path: "/pesanan",
  name: "pesanan",
  hidden: false,
  component: () => import("@/components/order/index"),
  meta: {
    title: "Status Pesanan",
    icon: "fa-list",
    roles: ["driver"]
  }
};
export default order;



// WEBPACK FOOTER //
// ./src/router/modules/order.js